import { render, staticRenderFns } from "./One_occupation.vue?vue&type=template&id=de569fbe&"
import script from "./One_occupation.vue?vue&type=script&lang=js&"
export * from "./One_occupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports